/**
 * Rack add-on selector.
 *
 * Lets a customer pick an add-on product (e.g. a storage rack) on a product page.
 * When they add the main product to cart, the chosen add-on variant is added at the
 * same time by intercepting the theme's <product-form> submit in the capture phase:
 * we add the add-on first, then let the original submit proceed so the returned cart
 * drawer / cart page already reflects both line items.
 */
(function () {
  function cartAddUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function init(widget) {
    if (widget.dataset.rackInit) return;
    widget.dataset.rackInit = '1';

    var info = widget.closest('.m-main-product--info');
    var productForm = info ? info.querySelector('product-form') : null;
    var form = productForm ? productForm.querySelector('form') : null;
    if (!productForm || !form) return;

    var nameEl = widget.querySelector('[data-rack-selected-name]');
    var tiles = widget.querySelectorAll('[data-rack-tile]');
    var radios = widget.querySelectorAll('input[name="rack-addon-choice"]');

    function refresh() {
      var selectedName = 'None';
      tiles.forEach(function (tile) {
        var input = tile.querySelector('input[name="rack-addon-choice"]');
        var checked = input && input.checked;
        tile.classList.toggle('is-selected', !!checked);
        if (checked) selectedName = tile.getAttribute('data-rack-name') || 'None';
      });
      if (nameEl) nameEl.textContent = selectedName;
    }

    radios.forEach(function (r) {
      r.addEventListener('change', refresh);
    });

    // --- Weight-based visibility ------------------------------------------
    // Hide a rack tile when the selected variant's weight (per dumbbell/kettlebell)
    // reaches that tile's threshold, e.g. hide the 10-tier rack at 12.5kg+.
    var weights = {};
    var weightScript = widget.querySelector('[data-rack-weights]');
    if (weightScript) {
      try {
        weights = JSON.parse(weightScript.textContent) || {};
      } catch (e) {
        weights = {};
      }
    }
    var idInput = form.querySelector('input[name="id"]');

    function currentWeight() {
      if (!idInput || !idInput.value) return NaN;
      return parseFloat(weights[idInput.value]);
    }

    function applyWeightRules() {
      var weight = currentWeight();
      var noneInput = widget.querySelector('input[value="none"]');
      tiles.forEach(function (tile) {
        var threshold = parseFloat(tile.getAttribute('data-rack-hide-at'));
        var hide = !isNaN(threshold) && !isNaN(weight) && weight >= threshold;
        tile.hidden = hide;
        if (hide) {
          var input = tile.querySelector('input[name="rack-addon-choice"]');
          if (input && input.checked && noneInput) noneInput.checked = true;
        }
      });
      refresh();
    }

    if (idInput) idInput.addEventListener('change', applyWeightRules);
    applyWeightRules();

    function selectedVariantId() {
      var checked = widget.querySelector('input[name="rack-addon-choice"]:checked');
      if (!checked || checked.value === 'none' || checked.disabled) return null;
      return checked.value;
    }

    // Capture phase on the <product-form> ancestor runs before the theme's own
    // submit handler (registered on the inner <form>), so we can add the add-on first.
    productForm.addEventListener(
      'submit',
      function (evt) {
        // Second pass: our re-submit — let it flow through to the theme handler.
        if (productForm.dataset.rackPass) {
          productForm.dataset.rackPass = '';
          return;
        }

        var variantId = selectedVariantId();
        if (!variantId) return; // No add-on chosen: normal add-to-cart.

        evt.preventDefault();
        evt.stopImmediatePropagation();

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .catch(function (err) {
            console.error('Rack add-on could not be added to cart:', err);
          })
          .then(function () {
            // Re-trigger the original submit so the main product is added and the
            // theme refreshes the cart (now containing the add-on too).
            productForm.dataset.rackPass = '1';
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              var btn = form.querySelector('[name="add"]');
              if (btn) btn.click();
            }
            // Reset back to NONE so the next add-to-cart doesn't re-add the rack.
            var noneInput = widget.querySelector('input[value="none"]');
            if (noneInput) noneInput.checked = true;
            refresh();
          });
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-rack-addon]').forEach(init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
